module.exports = {
    ratingreview: {
        reviewSource: [
            ['Bunch', 'Sourced from bunch.woolworths.com.au'],
            ['BazaarVoice', 'Independently moderated by bazaarvoice.com'],
        ],
        maxRating: 5,
        minRatingCount: 10,
        pageSize: 10,
        reviewCharCountBeforeViewMoreCutoff: 300,
        errorReviewMessage: 'No reviews currently available',
        minReviewCount: 10,
    },
};



// WEBPACK FOOTER //
// ./src/common/settings/groups/ratingreview.js